import React, {Component} from 'react';
import {TabContent, TabPane, Nav, NavItem, NavLink, Progress, Label, Input} from 'reactstrap';
import classnames from 'classnames';
import LoadingIndicator from '../../utils/LoadingIndicator'

class Aside extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            notifications: 'loading',
            loading: true
        };
    }
    componentDidMount() {

        this.setState({
            notifications: this.props.notifications,
            loading: false
        });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {

        if (this.props.notifications['notifications'] === 0) {
            return (
                <aside className="aside-menu">
                    <LoadingIndicator />
                </aside>
            );
        }


        return (
            <aside className="aside-menu">
                <div className="callout m-0 py-2 text-muted text-center bg-light text-uppercase">
                    <small><b>Notifications</b></small>
                </div>
                <hr className="transparent mx-3 my-0"/>


                {this.props.notifications['notifications'].map(function(notification,index){
                    if (notification.alarmed === true) {
                        return (
                            <div key={index} className={notification.type === 'mid' ? 'callout m-0 py-3 callout-warning' : 'callout m-0 py-3 callout-danger'}>
                                <div><strong>{notification.site}</strong></div>
                                <small className="text-muted"><i className="icon-location-pin"></i>&nbsp; {notification.device} Alarm</small>
                            </div>
                        )
                    }

                })}


            </aside>
        )
    }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js